import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { CoreModule } from '../core/core.module';
import { FooterComponent } from './components/footer/footer.component';

@NgModule({
  declarations: [FooterComponent],
  imports: [CommonModule, CoreModule],
  exports: [FooterComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApplicationBottomModule {}
